import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";

const Logout = () => {
    const history = useHistory();

    useEffect(() => {
        // Удаляем токен из локального хранилища
        localStorage.removeItem("accessToken");

        // Перенаправляем на страницу входа
        history.push(Routes.Signin.path);
    }, [history]);

    return null; // Компонент не рендерит ничего, так как происходит перенаправление
};

export default Logout;
